module.exports = "//static.hsappstatic.net/payments-enrollment-embed-lib/static-1.15544/images/StripeLogo.svg"